import { VStack } from "@chakra-ui/react";
import { Box, Col, Row } from "@reverb-ui/react";
import { SortedTable } from "presentation/components/SortedTable";
import { useContext, useMemo } from "react";
import { MetricCard } from "../../components/MetricCard";
import { ListCardSkeleton } from "presentation/components/Skeleton/CardSkeleton";
import { SortedTableSkeleton } from "presentation/components/Skeleton/SortedTableSkeleton";
import { panelsInfo } from "helper/panelsHelper";
import { CreativeGoalContext } from "../context-api/CreativeGoalProvider";
import { CompletionCell } from "./CompletionCell";
import { InsightsFeedbackEnum } from "data/constants/constants";
import { ExclamationTriangle } from "@reverb-ui/icons-react";
import PanelContainer from "presentation/components/PanelContainer";

const creativeGoalInfo = panelsInfo.creativeGoal;

export const CreativeGoalReports = () => {
  const {
    requestParamsIndex,
    creativeGoalData,
    downloadCreativeGoalReport,
    downloadingReports,
    isLoading,
  } = useContext(CreativeGoalContext);

  const { creativeGoals, cards } = creativeGoalData || {};
  const dueDateCardInfo = cards?.find((x) => x.order === 34);

  const creativeGoalRow = useMemo(() => {
    return creativeGoals?.dataRows.map((goal) => ({
      keyPerformanceIndicator: goal.keyPerformanceIndicator,
      currentValue: goal.currentValue,
      goalValue: goal.goalValue,
      completion: CompletionCell({
        value: goal.completion,
        dueDate: new Date(dueDateCardInfo?.text!),
      }),
    }));
  }, [creativeGoals]);

  if (!isLoading && cards?.length === 0) {
    return <></>;
  }

  return (
    <PanelContainer
      panelId={creativeGoalInfo.htmlId}
      panelName={creativeGoalInfo.description}
      isLoading={isLoading}
      downloadOptions={{
        onClickGenerateCSV: downloadCreativeGoalReport,
        downloadingReports: downloadingReports,
        panelInfo: creativeGoalInfo,
        filterStateIndex: requestParamsIndex,
      }}
    >
      <Row>
        <Col col={!isLoading && creativeGoalData?.cards.length === 0 ? 0 : 3}>
          {isLoading ? (
            <ListCardSkeleton numberOfCards={3} spacingBetween={7} />
          ) : (
            // @ts-ignore
            <VStack w="full" spacing={5}>
              {creativeGoalData?.cards.map((item, index) => (
                <MetricCard
                  key={index}
                  order={item.order}
                  iconName={item.iconTitle}
                  title={item.title}
                  description={item.text}
                  insight={{
                    feedback: InsightsFeedbackEnum.NEUTRAL,
                    message: item.outcomes,
                    icon: <ExclamationTriangle color="gray.500" />,
                  }}
                />
              ))}
            </VStack>
          )}
        </Col>
        <Col col={!isLoading && creativeGoalData?.cards.length === 0 ? 12 : 9}>
          <Box
            bg="white"
            w="full"
            p={6}
            height={350}
            overflow="auto"
            className="sortedTable"
          >
            {isLoading ? (
              <SortedTableSkeleton numberOfColumns={4} numberOfRows={4} />
            ) : (
              <SortedTable
                dataColumns={creativeGoalData?.creativeGoals.dataColumns || []}
                dataRows={creativeGoalRow || []}
              />
            )}
          </Box>
        </Col>
      </Row>
    </PanelContainer>
  );
};
